import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import './tags.css'
const Tags = ({
  data,
  handleValue,
  getTag,
  getTagById,
  prefilledData,
  postSalesData
}) => {
  const {
   tags
  } = data;
  // console.log('data >> ' + JSON.stringify(postSalesData));
  const [inputList, setInputList] = useState([{ tag_type:"",quantity: "", unit_price: "",status:"" }]);
  const [tagsData, setTagData] = useState();
  const [isTarget, setIsTarget] = useState('');
  
  useEffect(() => {
    if (postSalesData && postSalesData.tags && postSalesData.tags.length>0) {
      // Map postSalesData.tags to match the structure of inputList
      const updatedInputList = postSalesData.tags.map(tag => ({
        tag_type: tag.tag_type || "",
        quantity: tag.qty || "",
        unit_price: tag.price || "",
        status: tag.status || ""
      }));
      setInputList(updatedInputList);
    }
  }, [postSalesData]);
  useEffect(() => {
    if (
      prefilledData?.tagEditData !== undefined &&
      prefilledData?.tagEditData !== null
    ) {
      const tagData = prefilledData?.tagEditData;
      
      setTimeout(() => {
        if (tagData != '') {
          setInputList(tagData);
        }
      }, 100);

    }
  }, [prefilledData]);

    // Send data to parent - only called when needed
    const sendDataToParent = (data) => {
      if (data) {
        handleValue({
          tagData: data,
        });
      } else {
        handleValue(null);
      }
    };
  
    // Handle blur - update parent when user leaves field
    const handleInputBlur = () => {
      sendDataToParent(inputList);
    };

    // handle input change
    const handleInputChange = (e, index) => {
      // console.log(e);
      const { name, value } = e.target;
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list);
    };
    
    const handledropDownChange = (e, index,name) => {
      const { value,id} = e;
      const list = [...inputList];
      list[index][name] = id;
      setInputList(list);
      sendDataToParent(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {
      const list = [...inputList];
      list.splice(index, 1);
      setInputList(list);
      sendDataToParent(list);
    };
    
    // handle click event of the Add button
    const handleAddClick = () => {
      const newList = [...inputList, {tag_type:"", quantity: "", unit_price: "",status:"" }];
      setInputList(newList);
      sendDataToParent(newList);
    };

  return (
    <Fragment>
      <FormSection title={localization.tags}>
      
      {inputList.map((x, i) => {
      return (
        <Fragment key={i}>
        <div className="row" >
          <div className="col-5">
          <DropDownInput
          data={tags}
          label={localization.tags}
          // required
          // isStarRequired={true}
          errorMsg={localization.tags}
          getIdValue={(val) =>{
            setTagData({
              ...tagsData,
              tag_type: val.id ,
            });
            handledropDownChange(val,i,'tag_type');
          }
          }
          value={tags.find(tag => tag.id == x.tag_type)?.name || ''}
          // onChange={e => handleInputChange(e, i)}
        />
          </div>
          
           <div className="col-5">
           <input
            className="form-control"
            name="quantity"
            type="number"
            placeholder="Quantity"
            value={x.quantity}
            onChange={e => handleInputChange(e, i)}
            onBlur={handleInputBlur}
            min={1}
            // value={x.quantity}
          />
           </div>
           <div className="col-5">
           <DropDownInput
        
              label={localization.status}
              data={[
                { id: 'Free', name: 'Free' },
                { id: 'Paid', name: 'Paid' },
              ]}
              // required
              errorMsg={localization.status}
              getIdValue={(val) =>{
                setTagData({
                  ...tagsData,
                  status: val.id,
                });
                handledropDownChange(val,i,'status');
              }
              }
              value={x.status}
              // onChange={e => handleInputChange(e, i)}
              
              // isStarRequired={true}
          />
      
      </div>

           <div className="col-5">
             {x.status && x.status == 'Paid' && (
              <input
              className="form-control"
              type="number"
              name="unit_price"
              placeholder="Unit Price"
              // value={x.lastName}
              onChange={e => handleInputChange(e, i)}
              onBlur={handleInputBlur}
              value={x.unit_price}
              min="1"
            />
             )}
        
          </div>
          <div className="btn-box">
            {inputList.length !== 1 && <button
              onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger mr10">Remove</button>}
            {inputList.length - 1 === i && <><br/>
            <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button></>}
          </div>
         
        </div>
         <hr/>
         </Fragment>
      );
    })} 
        {/* <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div> */}
      
      </FormSection>
      
    </Fragment>
  );
};
Tags.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default Tags;
